module.exports = __webpack_public_path__ + "static/flags/QA-2268fda69c037f50a9121be4edc51480.gif";